<template>
  <div id="equipa">
    <div class="extensao_banner">
      <BreadCrumb :breadcrumb="breadcrumb" class="bcp"/>
      <h1>SASUMA / {{ $t("UMA_LANG_BIBLIOTECA_EQUIPA") }}</h1>
    </div>
    <div class="row align-center">
      <div class="small-10 medium-10 large-9 columns">
        <div class="row">
          <Pessoa 
            :url="pessoa.url" 
            :nome="pessoa.nome" 
            :email="pessoa.email" 
            :imagem="pessoa.imagem"
            v-for="pessoa in equipa" />
        </div>
      </div>
    </div>
    <router-link to="/" 
      class="close-button equipaCloseBtn" 
      data-close 
      aria-label="Close modal"
      type="button">
        <span aria-hidden="true">&times;</span>
    </router-link>
  </div>
</template>

<script>
import { ref } from "vue";
import axios from "@/axios";
import Pessoa from "@/components/Pessoa.vue";
import { BreadCrumb } from "umaui";
import { i18n } from "@/main.js";
import { onBeforeRouteLeave } from 'vue-router'


export default {
  components: {
    Pessoa,
    BreadCrumb
  },
  setup() {

    const { t } = i18n.global;
    const lang = i18n.global.locale;

    const lg = lang == "en" ? "/en" : "";

    const breadcrumb = ref([
      { ID: 1, text: 'Homepage', href: `https://www.uma.pt${lg}` },
      { ID: 2, text: t("breadcrumb.sobre"), href: `https://www.uma.pt${lg}/sobre` },
      { ID: 2, text: t("breadcrumb.apoio"), href: `https://www.uma.pt${lg}/sobre/servico-apoio-estudantes` },
      { ID: 2, text: t("breadcrumb.sas"), route: { to: "/" } },
      { ID: 3, text: t("breadcrumb.equipa"), href: "#"}
    ]);

    const equipa = ref([]);

    axios.get("/sas/equipa").then(response => {
      equipa.value = response.data;
    }).catch(error => {
      console.log(error);
    })

    var navigationbar = document.getElementsByClassName("title-bar")[0];
    navigationbar.classList.add("black");
    var offcontent = document.getElementsByClassName("off-canvas-content")[0];
    offcontent.classList.add("padding");

    onBeforeRouteLeave(async (to, from) => {
      console.log("onBeforeRouteLeave")
      var navigationbar = document.getElementsByClassName("title-bar")[0];
      navigationbar.classList.remove("black");
      var offcontent = document.getElementsByClassName("off-canvas-content")[0];
      offcontent.classList.remove("padding");
    });


    return {
      breadcrumb,
      equipa
    }
  }
}
</script>

<style lang="scss" scoped>
.extensao_banner h1 {
  text-align: center;
  font-family: Montserrat Bold;
  font-size: 60px;
  color: #3f4244;
  padding-top: 105px;
  padding-bottom: 30px;
  transform: translate3D(0,-10px,0);
}

.extensao_banner h1 {
  font-size: 55px;
  color: #4d5354;
}

.bcp {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
  padding-top: 15px;
  top: 110px;
}

@media (max-width: 1400px) {
  .extensao_banner h1 {
    font-size: 48px;
  }
}

@media (max-width: 767px) {
  .extensao_banner h1 {
    font-size: 25px !important;
    padding-top: 35px;
    padding-bottom: 0px;
  }
}

.equipaCloseBtn{
    display: none;
}

@media (max-width: 767px) {
  .equipaCloseBtn{
    display: block;
    top: 120px;
  }
}
</style>